import axios from 'axios';

// 学校免请假通行时间列表
export function noLeaveTimeList(params) {
  return axios({
    url: '/school/noLeaveTime/list',
    method: 'GET',
    params: params,
  });
}

// 学校免请假通行时间新增
export function noLeaveTimeSave(data) {
  return axios({
    url: '/school/noLeaveTime/save',
    method: 'POST',
    data: data,
  });
}

// 学校免请假通行时间修改
export function noLeaveTimeUpdate(data) {
  return axios({
    url: '/school/noLeaveTime/update',
    method: 'POST',
    data: data,
  });
}

// 学校免请假通行时间删除
export function noLeaveTimeDelete(data) {
  return axios({
    url: '/school/noLeaveTime/delete',
    method: 'POST',
    data: data,
  });
}
